const CARD_SELECTOR = ".x86-page__downloadCard--embed";

/** 仅 (150%, 200%]：锁住相对 150% 的屏内比例；其余倍率清除，其它逻辑不动 */
const LOCK_FROM = 1.5;
const LOCK_TO = 2;

function readBrowserPageScale(): number {
	const vv = window.visualViewport?.scale;
	if (typeof vv === "number" && Number.isFinite(vv) && vv >= 1.05) {
		return Math.min(5, vv);
	}

	const inner = window.innerWidth;
	const outer = window.outerWidth;
	if (inner < 1 || outer < 1) {
		return 1;
	}

	const ratio = outer / inner;
	if (ratio >= 1.2 && ratio <= 5) {
		return Math.min(5, ratio);
	}
	return 1;
}

function clearLock(card: HTMLElement): void {
	card.style.removeProperty("transform");
	card.style.removeProperty("transform-origin");
}

/**
 * 150%→200% 时 CSS 视口变窄，clamp 的 px 上限使卡片相对屏幕变大并被裁切。
 * 用 scale(1.5/pageScale) 抵消该偏移，使观感锁定在 150%；
 * ≤150% 与 >200% 不写入任何样式。
 */
function applyLock(card: HTMLElement, pageScale: number): void {
	if (pageScale <= LOCK_FROM || pageScale > LOCK_TO) {
		clearLock(card);
		return;
	}

	const s = LOCK_FROM / pageScale;
	card.style.transformOrigin = "center center";
	card.style.transform = `scale(${s})`;
}

export function bindX86EmbedCardLock150To200(root: HTMLElement): () => void {
	const card = root.querySelector<HTMLElement>(CARD_SELECTOR);

	const sync = () => {
		if (!card) {
			return;
		}
		applyLock(card, readBrowserPageScale());
	};

	sync();
	requestAnimationFrame(() => {
		sync();
		requestAnimationFrame(sync);
	});
	const lateTimers = [120, 400, 1200].map((ms) => window.setTimeout(sync, ms));

	const onViewportChange = () => sync();
	window.visualViewport?.addEventListener("resize", onViewportChange);
	window.visualViewport?.addEventListener("scroll", onViewportChange);
	window.addEventListener("resize", onViewportChange);

	return () => {
		lateTimers.forEach((id) => window.clearTimeout(id));
		window.visualViewport?.removeEventListener("resize", onViewportChange);
		window.visualViewport?.removeEventListener("scroll", onViewportChange);
		window.removeEventListener("resize", onViewportChange);
		if (card) {
			clearLock(card);
		}
	};
}
